import { Theme, SxProps } from '@mui/material';
import {
  SelectInput as AdminSelectInput,
  SelectInputProps as AdminSelectInputProps,
} from 'react-admin';
import { fieldWidth } from 'themes/layout';

export type SelectInputProps = AdminSelectInputProps & { shrink?: boolean };

export const SelectInput: React.FC<SelectInputProps> = ({
  sx,
  InputLabelProps,
  shrink = true,
  ...restProps
}) => {
  const defaultSx: SxProps<Theme> = {
    '&.MuiFormControl-root': {
      margin: 0,
    },
    ...fieldWidth.medium,
  };
  return (
    <AdminSelectInput
      InputLabelProps={{ shrink: shrink || undefined, ...InputLabelProps }}
      sx={{ ...defaultSx, ...sx }}
      {...restProps}
    />
  );
};
